import { Helmet } from 'react-helmet-async';

const Meta = ({ title, description, keywords }) => {

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
    </Helmet>
  )
}

Meta.defaultProps = {
  title: "小馬麻手作烘焙坊",
  description: "小馬麻手作烘焙坊 — 手作烘焙、用心製作的甜點小舖",
  keywords: "手作烘焙, 甜點, 蛋糕, 餅乾, 烘焙坊, 小馬麻",
};

export default Meta;